
import React from 'react';

import LoopIcon from '../../public/assets/icons/loop';
import styles from './styles.module.scss';

interface ISearchBar {
  search: string;
  setSearch(search: string): void;
  placeholder: string;
  inputRef?: React.RefObject<HTMLInputElement>;
}

const SearchBar = ({ search, setSearch, placeholder, inputRef }: ISearchBar) => {
  return (
    <div className="transparent-input">
      <div className={styles.searchBar}>
        <section className={styles.loopIcon}>
          <LoopIcon />
        </section>

        <input
          ref={inputRef}
          className={styles.searchInput}
          type="text"
          value={search}
          onChange={e => setSearch(e.target.value)}
          placeholder={placeholder}
        />
      </div>
    </div>
  );
};

export default SearchBar;